
<agpr-take-over-panel
    [id]="'generateReportDialog'"
    [header]="'Reports.sharedReportEditDialog'"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="closeDialog()"
    [width]="35"
>
    <div
        class="agpr-sharedReportEditDialog-content"
        [agprLoading]="globalSeriesState === seriesStates.loading"
    >
        <div class="agpr-sharedReportEditDialog-topPanel">
            <agpr-panel
                [header]="'Reports.sharedReportEditDialog.report'"
                [toggleable]="false"
                class="agpr-sharedReportEditDialog-panelContent"
            >
                <p class="agpr-sharedReportEditDialog-panelContent-message">{{ 'Reports.sharedReportEditDialog.message' | localize }}</p>
                <agpr-attribute-list
                    [attributes]="editSharedReportDetails"
                    [isGrid]="true"
                ></agpr-attribute-list>
            </agpr-panel>
        </div>
        <div class="agpr-sharedReportEditDialog-bottomPanel">
            <agpr-panel
                [header]="'Reports.sharedReportEditDialog.content'"
                [toggleable]="false"
                class="agpr-sharedReportEditDialog-panelContent"
            >
                <agpr-checkboxes-field
                    id="sharedReportEditDialog_updateOptions"
                    [value]="selectedOptions"
                    [field]="checkboxFieldModel"
                    (changes)="selectedOptionsChanged($event)"
                ></agpr-checkboxes-field>
                <agpr-message
                    *ngIf="showWarning"
                    [severity]="messageSeverityEnum.error"
                >
                   {{'Reports.sharedReportEditDialog.content.updateChartSourceData.warning' | localize}}
                </agpr-message>
                <agpr-message
                    *ngIf="globalSeriesState === seriesStates.error"
                    [severity]="messageSeverityEnum.warning"
                >
                    {{'Reports.sharedReportEditDialog.content.updateChartSourceData.dataError' | localize}}
                </agpr-message>
            </agpr-panel>
            <agpr-message
                *ngIf="reportError"
                [severity]="messageSeverityEnum.error"
            >
            {{'Reports.sharedReportEditDialog.content.updateChartSourceData.reportError' | localize}}
            </agpr-message>
        </div>
    </div>
    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="Core.button.cancel"
            id="sharedReportEditDialog.cancelButton"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            id="sharedReportEditDialog.nextStep"
            label="Reports.sharedReportEditDialog.next"
            [disabled]="reportError || !sourceReport || (globalSeriesState !== seriesStates.loaded && globalSeriesState !== seriesStates.error) "
            [loading]="!reportError && (!sourceReport || (globalSeriesState !== seriesStates.loaded)) && globalSeriesState !== seriesStates.error"
            [style]="buttonTypes.primary"
            (click)="updateSharedReport()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
